import { api, API_BASE } from './api';

export const workflowApi = {
  getHistory: (params = {}) => api.get('/api/v1/admin/workflow/history', params),
  getRedisState: () => api.get('/api/v1/admin/workflow/redis'),
  // Mercure subscription for live workflow updates: { hub_url, topic, token }
  getLive: () => api.get('/api/v1/admin/workflow/live'),
  defaultHubUrl: () => `${API_BASE}/.well-known/mercure`,
};
